'use client';

import { useEffect, type FC } from 'react';
import { useLanguageAlternatesStore, type LanguageAlternates } from '../i18n/languageAlternates';

export const LanguageAlternatesSync: FC<{ alternates: LanguageAlternates }> = ({ alternates }) => {
  const setAlternates = useLanguageAlternatesStore((state) => state.setAlternates);

  useEffect(() => {
    setAlternates(alternates);
    return () => setAlternates(null);
  }, [alternates, setAlternates]);

  return null;
};
